var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDireccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "#285171"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.0001V8.66675H13.6667L10 12.3334L13.6667 16.0001H23ZM23 8.66675V36.6667M23 16.0001H32.3333L36 19.6667L32.3333 23.3334H23M23 16.0001V23.3334M23 23.3334H13.6667L10 27.0001L13.6667 30.6667H23V23.3334Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDireccion);
export default __webpack_public_path__ + "static/media/ic_direccion.11020595f47198f409436584f6a5618d.svg";
export { ForwardRef as ReactComponent };